module.exports = __webpack_public_path__ + "static/cover-cd9da3e7397b4d000c71006340a1418e.jpeg";